import { ChainId } from '@padiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x0747CFe82D3Bee998f634569FE2B0005dF9d8EDE', // TODO
  [ChainId.TESTNET]: '0xacbc13523fE673dCF8bf549AF00B5b4F9D9aBB6e'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
